export const DEFAULT_CHILD_NAME = 'Child';
